import { AxiosResponse } from "axios";
import LoginService from "pages/login/login.service";
import { EventoNotaFiscalEmitida } from "pages/pagamento/pagamento.model";
import { axiosRequest } from "../../axios/axios.config";
import {
  FlowConsignadoConsignarResponseDTO,
  FlowConsignadoDTO,
  FlowConsignadoObservacaoDTO,
  FlowConsignadoQtdValoresDTO,
} from "./detail/consignado-detail.model";
import {
  FlowConsignadoDevolucaoListItensResponseDTO,
  Itens,
} from "./devolucao/consignado-devolucao.model";
import {
  FlowConsignadoListFilterPayloadDTO,
  FlowConsignadoListResponseDTO,
} from "./list/consignado-list.model";
import { FlowConsignadoVisualizarNotasDTO } from "./movimentacoes/movimentacoes.model";
import { FlowConsignadoVisualizarDTO } from "./visualizar/consignado-visualizar-dialog.model";

const ConsignadoService = () => {
  const path = "/flow/consignado";
  const loginService = LoginService();

  return {
    list(filter: FlowConsignadoListFilterPayloadDTO): Promise<
      AxiosResponse<{
        itens: FlowConsignadoListResponseDTO[];
        quantidadesValores: FlowConsignadoQtdValoresDTO;
      }>
    > {
      return axiosRequest.post(`${path}/list`, filter, {
        headers: loginService.getHeaders(),
      });
    },

    visualizar(
      uuidConsignado: string
    ): Promise<AxiosResponse<FlowConsignadoVisualizarDTO>> {
      return axiosRequest.get(`${path}/visualizar/${uuidConsignado}`, {
        headers: loginService.getHeaders(),
      });
    },

    loadConsignado(
      uuidConsignado: string
    ): Promise<AxiosResponse<FlowConsignadoDTO>> {
      return axiosRequest.get(`${path}/loadconsignado/${uuidConsignado}`, {
        headers: loginService.getHeaders(),
      });
    },

    salvar(
      consignado: FlowConsignadoDTO
    ): Promise<AxiosResponse<FlowConsignadoDTO>> {
      return axiosRequest.post(`${path}/salvar`, consignado, {
        headers: loginService.getHeaders(),
      });
    },

    finalizarConsignado(
      consignado: FlowConsignadoDTO,
      outros: boolean
    ): Promise<AxiosResponse<FlowConsignadoConsignarResponseDTO>> {
      return axiosRequest.post(`${path}/consignar`, consignado, {
        headers: loginService.getHeaders(),
        params: { outros },
      });
    },

    visualizarNotas(
      uuidConsignado: string
    ): Promise<AxiosResponse<FlowConsignadoVisualizarNotasDTO>> {
      return axiosRequest.get(`${path}/visualizarnotas/${uuidConsignado}`, {
        headers: loginService.getHeaders(),
      });
    },

    getItensDevolucao(
      uuidConsignado: string
    ): Promise<AxiosResponse<FlowConsignadoDevolucaoListItensResponseDTO>> {
      return axiosRequest.get(`${path}/itensdevolucao/${uuidConsignado}`, {
        headers: loginService.getHeaders(),
      });
    },

    devolver(
      uuidConsignado: string,
      itens: Itens,
      isSimbolica: boolean
    ): Promise<AxiosResponse<EventoNotaFiscalEmitida>> {
      return axiosRequest.post(
        `${path}/devolver`,
        {
          uuidConsignado,
          itens,
          isSimbolica,
          deveRemoverItensDevolvidos: true,
        },
        { headers: loginService.getHeaders() }
      );
    },

    confirmarDevolver(
      uuidConsignado: string,
      itens: Itens,
      isSimbolica: boolean
    ): Promise<AxiosResponse<EventoNotaFiscalEmitida>> {
      return axiosRequest.post(
        `${path}/confirmar-devolver`,
        {
          uuidConsignado,
          itens,
          isSimbolica,
          deveRemoverItensDevolvidos: true,
        },
        { headers: loginService.getHeaders() }
      );
    },

    excluirNota(chaveAcesso: string): Promise<AxiosResponse<void>> {
      return axiosRequest.delete(`${path}/excluir-nota/${chaveAcesso}`, {
        headers: loginService.getHeaders(),
      });
    },

    gerarVenda(
      uuidConsignado: string
    ): Promise<AxiosResponse<{ uuid: string; numeroPedido: string }>> {
      return axiosRequest.post(`${path}/gerar-venda/${uuidConsignado}`, null, {
        headers: loginService.getHeaders(),
      });
    },

    getObservacao(
      uuidConsignado: string
    ): Promise<AxiosResponse<FlowConsignadoObservacaoDTO | null>> {
      return axiosRequest.get(`${path}/observacao/${uuidConsignado}`, {
        headers: loginService.getHeaders(),
      });
    },

    setObservacao(
      uuidConsignado: string,
      observacao: string | undefined | null
    ): Promise<AxiosResponse<FlowConsignadoObservacaoDTO | null>> {
      return axiosRequest.put(
        `${path}/observacao`,
        {
          uuid: uuidConsignado,
          observacao,
        },
        {
          headers: loginService.getHeaders(),
        }
      );
    },

    cancelar(
      uuidConsignado: string,
      uuidMotivo: string
    ): Promise<AxiosResponse<void>> {
      return axiosRequest.put(
        `${path}/cancelar/${uuidConsignado}/${uuidMotivo}`,
        null,
        {
          headers: loginService.getHeaders(),
        }
      );
    },
  };
};

export default ConsignadoService;
